import React from "react";
import List from "./List";

function CommonMainList({ collectionData }) {
  const iterableArr = collectionData?.slice(1, collectionData.length);

  return iterableArr.map((data, idx) => {
    if (!data) return null;

    return (
      <List
        key={data.id || idx}
        data={data}
        dataLength={iterableArr?.length}
        idx={idx}
      />
    );
  });
}

export default CommonMainList;
